'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var svg_path = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M6 19.1683V4.83167C6 4.0405 6.87525 3.56266 7.54076 3.99049L18.6915 11.1588C19.3038 11.5525 19.3038 12.4475 18.6915 12.8412L7.54076 20.0095C6.87525 20.4373 6 19.9595 6 19.1683Z\" stroke=\"#26201F\" stroke-width=\"1.5\" stroke-linejoin=\"round\"/>\n</svg>";

exports["default"] = svg_path;
